var bannerSwiper = [];
var bannerSwiperIndex = 0;
export default ({
    name : 'Header'
    , data () {
        return {
            originBgImage : ''
            , originProfileHeight : 0
            , shopNameDefault : 'SHOP'
            , bannerCount : 0
        }
    }
    , created () {
        this.code = 'common_header';
        this.basic = this.getDetailDataByCode(this.code);
        if (this.isSetBasicData('prf_bg_img')) {
            this.originBgImage = this.basic.data.prf_bg_img.value
        }
        if (this.isSetBasicData('banner_image')) {
            this.originBannerList = this.basic.data.banner_image.value
        }
        this.shopConfig = this.getDetailDataByCode('shop_config');
        return {}
    }
    , mounted () {
        if (typeof _cart != 'undefined' && document.querySelector('.MSH-cart-cnt') != null) {
            _cart.init(cartTotalCnt)
        }
        if (templateType == 'simple') {
            bgResizing();
        }
        this.addHeaderGap();
    }
    , computed : {
        isUseHeader () {
            if (this.basic.use == 'N') return false;
            return true;
        }
        , isUsePrfIntro () {
            if (this.isSetBasicData('prf_introduce') === false) return false;
            if (this.basic.data.prf_introduce.value.length == 0) return false;
            return true;
        }
        , profileBgStyle () {
            let backStyle = {}
            if (this.isSetBasicData('prf_bg_img') === true && this.basic.data.prf_bg_img.value.length > 0) {
                let prfBgImgValue = this.basic.data.prf_bg_img.value
                backStyle['backgroundImage'] = `url(${prfBgImgValue})`
                backStyle['backgroundPosition'] = "50% 50%";
                backStyle['backgroundRepeat'] = "no-repeat";
                backStyle['backgroundSize'] = "cover"
            }
            if (this.isSetBasicData('prf_bg_color') === true) {
                let prfBgColor = this.basic.data.prf_bg_color.value
                backStyle['backgroundColor'] = `#${prfBgColor}`
            }
            return backStyle
        }
        , profileBgColorStyle () {
            let backStyle = {}
            if (this.isSetBasicData('prf_bg_color') === true) {
                let prfBgColor = this.basic.data.prf_bg_color.value
                backStyle['backgroundColor'] = `#${prfBgColor}`
            }
            return backStyle
        }
        , isUseProfileLogo () {
            return this.isSetBasicData('prf_logo')
        }
        , profileLogoStyle () {
            let prfBgImgValue = (this.basic.data.prf_logo.value.length > 0) ? this.basic.data.prf_logo.value : this.basic.data.prf_logo.default
            return { backgroundImage : "url(" + prfBgImgValue + ")" }
        }
        , isShowProfileLogo () {
            if (this.basic.data.prf_logo.value.length > 0) return true
            return false
        }
        , headerOverlayStyle () {
            if (this.isSetBasicData('prf_bg_alpha') === false) return {}
            return { opacity : this.basic.data.prf_bg_alpha.value * 0.01 }
        }
        , textColorStyle () {
            if (this.isSetBasicData('prf_text_color') === false) return {}
            return { color : '#' + this.basic.data.prf_text_color.value }
        }
        , profileIconColorClass () {
            if (this.isSetBasicData('prf_icon_color') === false) return ''
            return 'bg' + this.basic.data.prf_icon_color.value
        }
        , profileIconColorBorderBottomStyle () {
            if (this.isSetBasicData('prf_icon_color') === false) return {}
            return { 'border-bottom' : `2px solid #${this.basic.data.prf_icon_color.value}` }
        }
        , shopName () {
            if (this.isSetBasicData('shop_name') === false) return this.shopNameDefault 
            if (this.basic.data.shop_name.value.length == 0) return this.basic.data.shop_name.default
            return this.basic.data.shop_name.value
        }
        , prfIntroduce () {
            if (this.isSetBasicData('prf_introduce') === false) return '' 
            return this.basic.data.prf_introduce.value
        }
        , prfBgImage () {
            if (this.isSetBasicData('prf_bg_img') === false) return ''
            if (this.basic.data.prf_bg_img.value.length == 0) return ''
            return this.basic.data.prf_bg_img.value;
        }
        , isUseCategory : function () { // 카테고리 사용 미사용으로 인한 UI 변경 필요한경우.
            let hamburgerMenuData = this.getDetailDataByCode('hamburger_menu')
            if (hamburgerMenuData.use == 'N') { return false; }
            if (hamburgerMenuData.data.category_use.value == 'N') { return false; }
            return true;
        }
        , notUseBannerStyle () {
            let style = {
                'backgroundColor' : '#ddd'
            }
            if (this.useDesignBanner() === false) return style
			// 특별처리 border 색 변경
			if (this.basic.data.dimClass == false) return { 'border-bottom' : `1px solid #fff` }
            return {} 
        }
        , notUseBannerVisualTopStyle () {
            let style = {
				'overflow' : 'hidden'
            }
            if (this.useDesignBanner() === false) return style
            return {}
        }
        , linkHome () {
            return this.getAdminEditMode() ? 'javascript:void(0);' : this.urlHome
        }
        , linkCart () {
            return this.getAdminEditMode() ? 'javascript:void(0);' : this.urlCart
        }
        , linkMyOrder () {
            return this.getAdminEditMode() ? 'javascript:void(0);' : this.urlMyOrder
        }
        , linkMyPage () {
            return this.getAdminEditMode() ? 'javascript:void(0);' : this.urlMyPage
        }
        , linkLogin () {
            return this.getAdminEditMode() ? 'javascript:void(0);' : this.urlLogin
        }
        , bannerList () {
            this.fileterCurrentBannerImageDefault()
            let bannerData = this.basic.data
            let maxCnt = bannerData.banner_max_cnt.value;
            let list = []
            let originList = []
            for (let key in bannerData.banner_image.value) {
                if (bannerData.banner_image.value[key].length < 1) { continue; }
                if (maxCnt <= list.length) { break; }
                let link = this.getBannerLink(bannerData.banner_link_type.value[key], bannerData.banner_link.value[key], bannerData.banner_link_id.value[key]);
                let item = {
                    'image' : bannerData.banner_image.value[key]
                    , 'link' : link.link
                    , 'target' : link.target
                }
                list.push(item);
                originList.push(bannerData.banner_image.value[key])
            }
            this.bannerCount = list.length
            return list
        }
		, dimClass () {
            if (this.basic.data.dimClass == false) return ''
            return 'dim'
        }
        , getCustomName() {
            return this.shopConfig.custom_name;
        }
        , getHeaderBannerLink() {
            return this.shopConfig.header_banner_link;
        }
    }
    , methods : {
        fileterCurrentBannerImageDefault () {
            if (this.isEmptyBannerImage()) {
                if (this.isEmptyBannerDefault()) {
                    return []
                }
                this.basic.data.banner_image.value = this.basic.data.banner_image.default
            }
        }
        , isMultipleBanner () {
            //if (this.isSetBasicData('banner_image') && this.bannerList().length > 1) return true;
            //return false;
            return (this.bannerCount > 1) 
        }
        , isEmptyBannerDefault () {
            let bannerData = this.basic.data;
            return (bannerData.banner_image.default.length == 0)
        }
        , isEmptyBannerImage () {
            let bannerData = this.basic.data;
            if (bannerData.banner_image.value.length == 0) return true
            let list = []
            for (let key in bannerData.banner_image.value) {
                if (bannerData.banner_image.value[key].length > 0) {
                    list.push(bannerData.banner_image.value[key])
                }
            }
            return (list.length < 1)
        }
        , setBannerSwipe () {
            let option = {
                initialSlide : 0
                , loop: true
                , autoplay: {
                    delay: 3000
                }
                , slidesPerView: 1
                , pagination: {
                    el: '.swiper-pagination',
                }
                , autoHeight : true
                , a11y : false
            }

            this.deleteBannerSwipe()
            let bannerTpl = $m('#tpl-design .banner-slide-tpl').html()
                bannerTpl = `<div class="visualTop swiper-container banner-slide" :style="${this.notUseBannerVisualTopStyle}">${bannerTpl}</div>`
            $m('#tpl-design #header').parent().append(bannerTpl);
            bannerSwiper[bannerSwiperIndex] = new Swiper('#tpl-design .banner-slide', option);
            bannerSwiperIndex++;
            if (this.getAdminEditMode()) {
                this.areaSettingDisplayNone()
            }
        }
        , deleteBannerSwipe () {
            $m('#tpl-design .banner-slide').remove();
            if (bannerSwiperIndex > 0) {
                let bannerSwiperIndexPre = parseInt(bannerSwiperIndex) - 1
                if (bannerSwiper[bannerSwiperIndexPre]) { delete bannerSwiper[bannerSwiperIndexPre] }
            }
        }
        , bannerSwipe () {
            if (this.isMultipleBanner()) {
                this.setBannerSwipe()
                return;
            } 
            this.deleteBannerSwipe()
        }
        , areaSettingDisplayNone() {
            let btn = document.querySelectorAll('.visualTop .btn-area-setting')
            let border = document.querySelectorAll('.visualTop .section-border')
            for (let i=0; i<btn.length; i++) {
                btn[i].style.display = 'none'
            }
            for (let j=0; j<border.length; j++) {
                border[j].style.display = 'none'
            }
        }
        , useDesignBanner () {
            if (this.isSetBasicData('banner_image') && this.isSetBasicData('banner_max_cnt') === false) return false
            let bannerData = this.basic.data;
            if (bannerData.banner_image.value.length == 0) return false 
            if (bannerData.banner_max_cnt.value.length == 0) return false 
            return true
        }
        , checkOriginBannerList (bannerImage) {
            let chk = true
            if (this.isSetBasicData('banner_image') === false) return false
            if (this.originBannerList.length == 0) return false
            for (let i in bannerImage) {
                for (let j in this.originBannerList) {
                    if (this.originBannerList[j].includes(bannerImage[i]) === false) {
                        chk = false
                        break
                    }
                }
                if (chk === false) break
            }
            return chk
        }
        , addHeaderGap () {
            if (! $m('#header').siblings('.gap').length) {
                $m('#header').after($m('<div>', {
                    'style':'display: block; width:100%;',
                    'class':'gap'
                }));
            }
            $m('#header').siblings('.gap').height($m('#header').outerHeight());
        }
    }
    , updated () {
        //this.bannerSwipe()
        if (templateType == 'blog') {
            let visualTopEle = document.querySelector('#tpl-blog .base .visualTop')
            if (typeof visualTopEle != 'undefined' && visualTopEle != null) {
                visualTopEle.style.paddingTop = `${document.querySelector('#tpl-blog #header').offsetHeight}px`
            }
        }
        if (templateType == 'simple') {
            if (this.originBgImage != this.basic.data.prf_bg_img.value) {
                bgResizing();
                this.originBgImage = this.basic.data.prf_bg_img.value;
            }
            if (this.originProfileHeight != $m('#tpl-simple #header .profile').height()) {
                bgResizing();
                this.originProfileHeight = $m('#tpl-simple #header .profile').height()
            }
        }
        if (templateType == 'design' && this.checkOriginBannerList(this.basic.data.banner_image.value) === false) {
            this.originBannerList = this.basic.data.banner_image.value
            this.bannerSwipe()
        }
        this.addHeaderGap();
    }
})
